/* This file is autogenerated, see readme.md for instructions */
import WarningFillSvgIcon from '@bloomreach/banana-theme/icons/warning-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const WarningFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <WarningFillSvgIcon />
    </Icon>
  );
});

WarningFillIcon.displayName = 'WarningFillIcon';

export default WarningFillIcon;
